module.exports = __webpack_public_path__ + "img/list_style_bullets.fad14ebb.png";